import responsiveTheme from './responsiveTheme';

// Export the responsive theme as the default theme
export default responsiveTheme;

// Export device detection utils
export { deviceDetection } from './responsiveTheme';

// Export gradient utilities
export { gradients, getGradientWithOpacity, gradientCSSVars } from './gradients';
